import { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * @param {string} endpoint - API path, default entry_pages translations
 */
export const useTranslations = (endpoint = '/entry_pages/translations') => {
  const [allPages, setAllPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllPages = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.get(endpoint);
        if (response.data && Array.isArray(response.data)) {
          setAllPages(response.data);
        } else {
          setAllPages([]);
        }
      } catch (err) {
        console.error('Error fetching translations:', err);
        setError(err.message || 'Error al cargar traducciones');
        setAllPages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAllPages();
  }, [endpoint]);

  return { allPages, loading, error };
};

export default useTranslations;
